module.exports = __webpack_public_path__ + "static/media/hilda-icon.d8c28b57.png";